import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserNotificationItem } from 'src/app/model/userNotificationItem';
import { UserNotificationService } from 'src/app/service/user.notification.service';

@Component({
  selector: 'app-user-notification-preview',
  templateUrl: './user-notification-preview.component.html',
  styleUrls: ['./user-notification-preview.component.scss']
})
export class UserNotificationPreviewComponent implements OnInit  {
  ccListString: String;
  isLoading: Boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) public emailReceived: UserNotificationItem,
  private dialogRef: MatDialogRef<UserNotificationPreviewComponent>,
  private notificationService: UserNotificationService) { }

  ngOnInit(): void {
    if(!this.emailReceived.content){
      this.isLoading=true;
      this.notificationService.getEmailContent(this.emailReceived.id).subscribe(content=>{
        this.emailReceived.content=content;
        this.isLoading=false;
      });
    }
  }
  closeDialog(): void{
    this.dialogRef.close();
  }
}
